import { Project } from "../types";

export const projects: Project[] = [
  {
    id: "candiani-spa-integration",
    title: "Sistema Integrazione Sage X3 @ Candiani SPA",
    description:
      "Ho progettato e sviluppato un sistema custom di raccolta dati e gestione della produzione nell'arco di 21 anni, curandone il completo riadattamento dal vecchio gestionale legacy al nuovo ERP Sage X3. Ho gestito l'intera migrazione mantenendo intatto il tracciamento real-time, la gestione ordini e garantendo la totale continuità operativa aziendale.",
    technologies: ["C#", ".NET", "SQL Server", "Sage X3", "MySQL"],
    category: "data",
    createdAt: "2023-06-05",
    imageUrl: "/previews/x3.jpg",
  },
  {
    id: "plc-db-interface",
    title: "Interfaccia PLC ↔ DB",
    description:
      "Ho preso in mano un sistema legacy (VB.NET + DBF) praticamente senza documentazione e l’ho portato su MySQL, migliorando tutta la comunicazione con PLC Siemens e rendendo il sistema molto più stabile. Ho virtualizzato il server, aggiunto monitoraggio errori quasi in tempo reale e strumenti di test/diagnostica che prima non esistevano. Il tutto senza stravolgere l’interfaccia per gli operatori. Alla fine ho anche unificato due stabilimenti con logiche e dati completamente diversi.",
    technologies: ["C#", "VB.NET", "MySQL", "Siemens PLC"],
    category: "plc",
    createdAt: "2015-07-09",
    imageUrl: "/previews/utit.webp",
  },
  {
    id: "filati-data",
    title: "Raccolta dati prova filati da sistemi Uster",
    description:
      'Prima del mio intervento, ogni prova filato produceva 7 fogli cartacei archiviati in armadi interi. Ho digitalizzato tutto: i report sono ora PDF consultabili in un click, e le singole analisi — che prima erano "fotografie" isolate della qualità — sono diventate un grafico animato che mostra l\'andamento nel tempo, rendendo immediatamente visibile qualsiasi deriva della macchina.',
    technologies: ["PHP", "JavaScript", "MySQL", "Chart.js"],
    category: "data",
    createdAt: "2005-07-08",
    imageUrl: "/previews/filatura.webp",
  },
  {
    id: "rfid-warehouse",
    title: "Magazzino automatico RFID su muletti collegati via WiFi",
    description:
      "Il magazzino (oltre 15.000 bancali su 3 aree) era gestito a memoria: trovare i rotoli per la spedizione era un incubo e si perdeva un sacco di tempo. Ho sviluppato un sistema con muletti Linde equipaggiati con PC industriali e antenne RFID, alimentati direttamente dalla batteria del muletto. Tracciamo automaticamente ogni movimento: presa, trasporto e deposito, più integrazione con la macchina di composizione pallet. Risultato: merce sempre rintracciabile e inventario annuale con solo ~30 incongruenze su 15.000 pezze, nonostante una rotazione di oltre metà magazzino ogni 3 mesi.",
    technologies: ["C#", "ASP.NET", "MySQL", "RFID"],
    category: "data",
    createdAt: "2013-11-11",
    imageUrl: "/previews/rfid.jpg",
  },
  {
    id: "gantt-programming",
    title: "Gantt per programmazione telai",
    description:
      "Gestione della programmazione di quasi 300 telai distribuiti su 4 sale in 2 stabilimenti. Ho sviluppato un sistema Gantt drag-and-drop che permetteva di organizzare facilmente le code di lavorazione, garantendo che ogni telaio fosse sempre alimentato correttamente. Il sistema coordinava anche il reparto di orditura (tintoria) con la filatura, evitando blocchi e mantenendo la produzione continua senza interruzioni.",
    technologies: ["JavaScript", "jQuery", "PHP", "MySQL"],
    category: "web",
    createdAt: "2006-09-02",
    imageUrl: "/previews/gantt.webp",
    addHtml: `<button
      onclick="window.open('/Gantt', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >Apri simulatore Gantt</button>`,
  },
  {
    id: "ballistic",
    title: "Ballistic",
    description:
      "Ho sviluppato un sistema per gestire gli scarti tessili secondo le normative sui rifiuti industriali. Ho implementato la classificazione e tracciatura di ogni balla in magazzino, garantendo visibilità completa su quantità e posizione. Ho introdotto l'uso di terminali portatili (calamai / sbippatori con memoria) durante la cernita per raccogliere i codici a barre, permettendo di generare automaticamente la packing list a fine lavorazione. Ho fatto in modo che il sistema garantisse un doppio controllo tra materiale registrato e peso reale sul camion, integrandolo col gestionale per avere documentazione sempre corretta e conforme. Il tutto è stato realizzato adattando al massimo l’hardware disponibile, evitando investimenti inutili su un processo che, essendo lo scarto rivendibile, era comunque economicamente rilevante.",
    technologies: ["C#", ".NET", "MySQL"],
    category: "data",
    createdAt: "2010-04-22",
    imageUrl: "/previews/Ballistic.webp",
  },
  {
    id: "calcost",
    title: "Calcost",
    description:
      "Ho realizzato un sistema web per il calcolo e la simulazione del costo tessuto, anche senza produzione reale. Inserendo le caratteristiche, ho fatto in modo che il sistema combinasse automaticamente costi di materiali e lavorazioni già configurati, permettendo simulazioni rapide sia economiche che tecniche. Ho implementato la possibilità di aggiornare al volo i listini variando una singola componente (materiale, lavorazione, telaio), con ricalcolo immediato su tutti i tessuti coinvolti. Ho inoltre gestito i vincoli reali di produzione (es. lavorazioni non compatibili su alcuni telai), fornendo risultati affidabili in pochi click e riducendo drasticamente tempi ed errori rispetto ai calcoli manuali. Questo mi ha permesso di rendere gestibili senza stress anche le collezioni semestrali, velocizzando la creazione e l’aggiornamento dei listini.",
    technologies: ["MySQL", "JQuery"],
    category: "web",
    createdAt: "2011-10-10",
      imageUrl: "/previews/CalCost.webp",
  },
  {
    id: "auto-planning",
    title: "Pianificazione automatica",
    description:
      "In collaborazione con un'azienda esterna fornitrice del motore base di pianificazione, ho curato l'intera architettura di integrazione. Il sistema univa i dati di consegna del gestionale con quelli del sistema di produzione in tempo reale (incluso il sistema Gantt), analizzando la 'fotografia' istantanea degli impianti per generare piani operativi dettagliati per ogni reparto. Inoltre, ho sviluppato un'espansione web dedicata per rendere l'intera piattaforma più intuitiva e fruibile dagli utenti. L'integrazione completa ha permesso di ottimizzare le date di consegna ai clienti, anticipare proattivamente eventuali ritardi e automatizzare la generazione degli ordini di acquisto per i semilavorati.",
    technologies: ["C#", ".NET", "MySql", "LINQ"],
    category: "data",
    createdAt: "2015-02-05",
    imageUrl: "/previews/wplan.webp",
  },
  {
    id: "measurement-portal",
    title: "Portale test macchine di misura",
    description:
      "Ho sviluppato un portale web moderno basato su .NET 9 e REST API. La piattaforma permette agli utenti l'accesso a uno store integrato per l'acquisto di Test Plan personalizzati o già collaudati. Questi piani di test permettono ai clienti finali di verificare e collaudare con estrema precisione gli iniettori utilizzando i banchi di prova supportati dall'azienda. L'intera architettura e documentazione di progetto è strutturata e mantenuta tramite Obsidian.",
    technologies: [".NET 9", "REST API", "C#", "Obsidian"],
    category: "web",
    createdAt: "2025-01-10",
    imageUrl: "/previews/portaletest.webp",
  },
  {
    id: "simulatore-iniettore",
    title: "Piccolo simulatore di iniezione",
    description:
      "Ho sviluppato un emulatore web interattivo che visualizza e simula il funzionamento interno di un iniettore diesel. Ho realizzato un pannello di controllo per regolare in tempo reale i parametri chiave — pressione, timing di apertura, fase motore e regime di rotazione — con una rappresentazione grafica animata del ciclo di iniezione che reagisce immediatamente a ogni modifica. L'obiettivo era offrire uno strumento didattico leggero, utilizzabile direttamente dal browser, per capire a colpo d'occhio come i diversi parametri influenzano la portata e la forma dell'iniezione.",
    technologies: [".NET", "React", "TypeScript"], // Tecnologie di esempio
    category: "web",
    createdAt: "2025-07-06",
    imageUrl: "/previews/iniettore.jpg",
    // --- MODIFICA QUI ---
    // Usa 'onclick' (HTML) invece di 'onClick' (React/JSX).
    // Le classi Tailwind 'className' diventeranno 'class' nell'HTML finale, quindi funzionano.
    addHtml: `<button
      onclick="window.open('/Iniettore', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >
      Apri Emulatore Iniettore
    </button>`,
  },
  {
    id: "einkino-web",
    title: "E-inkino Web Editor",
    description:
      "Ho realizzato un editor web per gestire schermi e-ink collegati ad Arduino. L'applicativo permette di comporre layout con immagini e testo direttamente dal browser, con anteprima fedele di come apparirà sul display, e di inviarli al dispositivo tramite Web API senza passare da software desktop o toolchain di sviluppo. Ho curato la conversione delle immagini nel formato accettato dal pannello e-ink (gestione del bianco/nero e del dithering) e reso il flusso di caricamento immediato, così che aggiornare il contenuto di uno schermo sia questione di pochi secondi.",
    technologies: ["Arduino", "E-ink", "JavaScript", "Web API"],
    category: "web",
    createdAt: "2026-03-22",
    imageUrl: "/previews/einkino.jpg",
    addHtml: `<button
      onclick="window.open('https://eink.walterdev.eu/', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >
      Apri Editor E-ink
    </button>`,
  },
  {
    id: "ans-request-inspector",
    title: "ans — Request Inspector",
    description:
      "Ho creato un servizio diagnostico che cattura qualsiasi richiesta HTTP in ingresso (GET, POST, PUT, DELETE…) e ne espone i dettagli su una pagina web, mostrando in chiaro il body, i query params e gli headers. Nasce per il debugging di webhook e integrazioni fra sistemi: invece di scrivere codice usa e getta per ispezionare cosa manda davvero un servizio esterno, basta puntarlo all'endpoint e leggere la richiesta formattata nel browser. L'ho realizzato con un piccolo servizio Node.js dietro nginx, gestito da pm2 come processo permanente, ed esposto su un sottodominio dedicato sempre raggiungibile.",
    technologies: ["Node.js", "nginx", "pm2"],
    category: "web",
    createdAt: "2026-04-06",
    imageUrl: "/previews/ans.webp",
    addHtml: `<button
      onclick="window.open('https://ans.walterdev.eu/', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >
      Apri Request Inspector
    </button>`,
  },
  {
    id: "wball-audio-orb",
    title: "WBall - Audio Orb",
    createdAt: "2025-11-23",
    imageUrl: "/previews/wball.jpg",
    description:
      "Ho sviluppato un'esperienza web interattiva in cui l'utente parla e una sfera 3D risponde a voce in tempo reale. Ho costruito l'interfaccia come Web Component con Lit e la visualizzazione con Three.js, con la geometria della sfera che si deforma reagendo all'audio in ingresso e uscita. La cattura del microfono avviene via Web Audio API con un AudioWorklet che estrae il PCM grezzo da inviare in streaming a Gemini Live Audio, che genera la risposta vocale nativa. Ho aggiunto un rate limiting lato client per tenere sotto controllo i costi delle API.",
    technologies: ["TypeScript", "Lit", "Three.js", "Gemini AI voice"],
    category: "web",
    cvModeOnly: true,
    addHtml: `<button
      onclick="window.open('/WBall', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >
      Apri Audio Orb
    </button>`,
  },
  {
    id: "curapiu-booking",
    title: "CuraPiù - Portale Prenotazioni Mediche",
    createdAt: "2026-07-07",
    imageUrl: "/previews/prenotazioni.webp",
    description:
      "Demo interattiva per portfolio che riproduce il workflow completo di un portale di prenotazioni mediche online. Sviluppata in React e TypeScript, include filtri di ricerca, logiche di disponibilità dinamiche per 20 medici su 10 specializzazioni, finto login (con ruoli Paziente e Medico/Agenda impegni), visualizzazione email fittizie, layout di stampa ricevuta e cruscotto statistiche con grafici SVG nativi.",
    technologies: ["React 19", "TypeScript", "Vite", "Tailwind CSS", "SVG"],
    category: "web",
    addHtml: `<button
      onclick="window.open('/Prenotazioni', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >
      Apri Portale Prenotazioni
    </button>`,
  },
  {
    id: "wfastpic",
    title: "WFastPic - Tributo open source a Picasa",
    createdAt: "2026-10-14",
    imageUrl: "/previews/wfastpic.jpg",
    description:
      "Di Picasa mi mancava soprattutto una cosa: passare in rassegna le foto di una vacanza, scegliere al volo quelle buone, sistemarle con un clic ed esportarle. Così ho sviluppato WFastPic, un'applicazione desktop open source per Windows pensata per le grandi raccolte di foto HEIC (iPhone, droni, fotocamere): griglia veloce anche con migliaia di scatti, selezione da tastiera (Spazio tiene, Canc scarta, 0–5 stelle), raggruppamento automatico delle raffiche e valutazione automatica che segnala foto mosse o scure. Ho realizzato un editor non distruttivo con ritagli suggeriti che non tagliano i volti, raddrizzamento e correzione automatica \"Ho fortuna\", oltre a cartelle per anno, mappa delle foto, riconoscimento dei volti eseguito in locale, supporto Live Photo e dati dei droni DJI, ed export JPEG con filigrana. Nessun account, nessun cloud: gli originali non vengono mai toccati.",
    technologies: ["C#", ".NET 10", "WinUI 3", "HEIC", "Inno Setup"],
    category: "web",
    addHtml: `<button
      onclick="window.open('https://wfastpic.walterdev.eu/it/', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >
      Apri sito WFastPic
    </button>`,
  },
  {
    id: "wpdf",
    title: "WPdf - Editor PDF gratuito e locale",
    createdAt: "2026-10-16",
    imageUrl: "/previews/wpdf.png",
    description:
      "Per correggere un modulo PDF già compilato serviva sempre un editor commerciale, e i servizi online obbligano a caricare documenti pieni di dati personali. Ho sviluppato WPdf, un editor PDF open source che si usa dal browser ma gira tutto sul proprio computer: un piccolo server Python su 127.0.0.1 (basato su PyMuPDF) che accetta solo richieste locali, senza caricare nulla su internet. Ho separato il documento in tre livelli con colori distinti — testo originale, annotazioni \"Macchina da scrivere\" create con Foxit e testi creati da WPdf — e reso i testi mobili: si creano, si spostano, si ridimensionano e solo alla fine si fissano sul PDF. Le lettere nelle caselle (codice fiscale, CAP) vengono riconosciute come un unico testo. Completano il tutto annulla/ripristina, salvataggio con copia di sicurezza e un eseguibile Windows a file singolo che si aggiorna da solo verificando lo SHA-256 della nuova versione.",
    technologies: ["Python", "PyMuPDF", "JavaScript", "HTML", "PyInstaller"],
    category: "web",
    addHtml: `<button
      onclick="window.open('https://github.com/Walt7/WPdf', '_blank')"
      class="w-full mt-4 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
    >
      Vedi WPdf su GitHub
    </button>`,
  },
];

